import aggBuilder from './agg-builder/agg-builder.module.js';
import aiFlags from './ai-flags/ai-flags.module.js';
import apps from './apps/apps.module.js';
import askPendo from './ask-pendo/ask-pendo.module.js';
import auth from './auth/auth.module.js';
import retentionTrends from './retention-trends/retention-trends.module.js';
import adoptionTrends from './adoption-trends/adoption-trends.module.js';
import trendsSettings from './trends/trends-settings.module.js';
import automationRules from './automation-rules/automation-rules.module.js';
import billing from './billing/billing.module.js';
import blacklist from './blacklist/blacklist.module.js';
import brand from './brand/brand.module.js';
import collaboration from './collaboration/collaboration.module.js';
import pendoCollaboration from './pendo-collaboration/pendo-collaboration.module.js';
import config from './config/config.module.js';
import coreEvents from './core-events/core-events.module.js';
import dashboards from './dashboards/dashboards.module.js';
import dataSync from './data-sync/data-sync.module.js';
import devicesConnection from './devices-connection/devices-connection.module.js';
import domains from './domains/domains.module.js';
import emails from './emails/emails.module.js';
import essentialContacts from './essential-contacts/essential-contacts.module.js';
import experiments from './experiments/experiments.module.js';
import features from './features/features.module.js';
import feedbackLinking from './feedback-linking/feedback-linking.module.js';
import permissionGroups from './feedback-linking/permission-groups/permission-groups.module.js';
import products from './feedback-linking/products/products.module.js';
import signingKeys from './feedback-linking/signing-keys/signing-keys.module.js';
import vendorUsers from './feedback-linking/vendor-users/vendor-users.module.js';
import vendors from './feedback-linking/vendors/vendors.module.js';
import feedbackProducts from './feedback-products/feedback-products.module.js';
import feedbackRequests from './feedback-requests/feedback-requests.module.js';
import feedbackSettings from './feedback-settings/feedback-settings.module.js';
import feedbackStatuses from './feedback-statuses/feedback-statuses.module.js';
import globalFilters from './global-filters/global-filters.module.js';
import goals from './goals/goals.module.js';
import groups from './groups/groups.module.js';
import guideCategories from './guide-categories/guide-categories.module.js';
import guideModals from './guide-modals/guide-modals.module.js';
import guides from './guides/guides.module.js';
import nps from './guides/nps/nps.module.js';
import resourceCenter from './guides/resource-center/resource-center.module.js';
import insights from './insights/insights.module.js';
import integrationKeys from './integrations/integration-keys/integration-keys.module.js';
import integrations from './integrations/integrations.module.js';
import integrationJira from './integrations/jira/jira.module.js';
import metadataProviders from './integrations/metadata-providers/metadata-providers.module.js';
import salesforce from './integrations/salesforce/salesforce.module.js';
import serviceAccounts from './integrations/service-accounts/service-accounts.module.js';
import webhooks from './integrations/webhooks/webhooks.module.js';
import itemGroups from './item-groups/item-groups.module.js';
import graph from './journeys/graph/graph.module.js';
import journeys from './journeys/journeys.module.js';
import labels from './labels/labels.module.js';
import layouts from './layouts/layouts.module.js';
import leftNav from './left-nav/left-nav.module.js';
import licenses from './licenses/licenses.module.js';
import localization from './localization/localization.module.js';
import metaGroups from './meta-groups/meta-groups.module.js';
import metadata from './metadata/metadata.module.js';
import ngRoute from './ng-route/ng-route.module.js';
import notifications from './notifications/notifications.module.js';
import oauth from './oauth/oauth.module.js';
import organization from './organization/organization.module.js';
import pagesAlerts from './pages-alerts/pages-alerts.module.js';
import pages from './pages/pages.module.js';
import suggestedPages from './pages/suggested-pages/suggested-pages.module.js';
import productEngagementScore from './product-engagement-score/product-engagement-score.module.js';
import productLines from './product-lines/product-lines.module.js';
import columns from './roadmaps/columns/columns.module.js';
import items from './roadmaps/items/items.module.js';
import modals from './roadmaps/modals/modals.module.js';
import roadmaps from './roadmaps/roadmaps-module/roadmaps.module.js';
import swimlanes from './roadmaps/swimlanes/swimlanes.module.js';
import savedFilters from './saved-filters/saved-filters.module.js';
import funnels from './saved-reports/funnels.module.js';
import paths from './saved-reports/paths.module.js';
import savedReports from './saved-reports/saved-reports.module.js';
import savedViews from './saved-views/saved-views.module.js';
import scheduledReports from './scheduled-reports/scheduled-reports.module.js';
import segments from './segments/segments.module.js';
import playlists from './session-replay/playlists.module.js';
import sessionReplay from './session-replay/session-replay.module.js';
import sharedTokens from './shared-tokens/shared-tokens.module.js';
import smartSegments from './smart-segments/smart-segments.module.js';
import stars from './stars/stars.module.js';
import statuses from './statuses/statuses.module.js';
import subscription from './subscription/subscription.module.js';
import superSubscription from './subscription/super/super.module.js';
import superTools from './super-tools/super-tools.module.js';
import surveys from './surveys/surveys.module.js';
import teams from './teams/teams.module.js';
import themes from './themes/themes.module.js';
import trackTypes from './track-types/track-types.module.js';
import userJourney from './user-journey/user-journey.module.js';
import history from './user-settings/history/history.module.js';
import userSettings from './user-settings/user-settings.module.js';
import users from './users/users.module.js';
import usersMinimal from './user-minimal/users-minimal.module.js';
import visitors from './visitors/visitors.module.js';
import filters from './voc-items/filters/filters.module.js';
import vocJira from './voc-items/jira/jira.module.js';
import vocRoadmaps from './voc-items/roadmaps/roadmaps.module.js';
import sources from './voc-items/sources/sources.module.js';
import vocTable from './voc-items/table/table.module.js';
import vocItems from './voc-items/voc-items.module.js';
import vocPollWizard from './voc-poll-wizard/voc-poll-wizard.module.js';
import vocPortal from './voc-portal/voc-portal.module.js';
import vocDrawers from './voc/drawers/drawers.module.js';
import vocLabels from './voc/labels/labels.module.js';
import vocModals from './voc/modals/modals.module.js';
import vocOnboarding from './voc/onboarding/onboarding.module.js';
import workflows from './workflows/workflows.module.js';

export default {
    organization,
    aggBuilder,
    insights,
    savedFilters,
    productLines,
    collaboration,
    pendoCollaboration,
    visitors,
    feedbackProducts,
    roadmaps: {
        namespaced: true,
        modules: {
            roadmaps,
            swimlanes,
            modals,
            columns,
            items,
        },
    },
    domains,
    userSettings: {
        ...userSettings,
        modules: {
            history,
        },
    },
    oauth,
    productEngagementScore,
    vocItems: {
        ...vocItems,
        modules: {
            filters,
            roadmaps: vocRoadmaps,
            jira: vocJira,
            table: vocTable,
            sources,
        },
    },
    licenses,
    goals,
    savedViews,
    config,
    feedbackSettings,
    auth,
    itemGroups,
    experiments,
    trackTypes,
    emails,
    brand,
    features,
    labels,
    stars,
    workflows,
    askPendo,
    retentionTrends,
    adoptionTrends,
    trendsSettings,
    pagesAlerts,
    groups,
    devicesConnection,
    coreEvents,
    userJourney,
    sharedTokens,
    subscription: {
        ...subscription,
        modules: {
            super: superSubscription,
        },
    },
    sessionReplay: {
        ...sessionReplay,
        modules: {
            playlists,
        },
    },
    integrations: {
        ...integrations,
        modules: {
            metadataProviders,
            jira: integrationJira,
            integrationKeys,
            salesforce,
            serviceAccounts,
            webhooks,
        },
    },
    scheduledReports,
    globalFilters,
    voc: {
        namespaced: true,
        modules: {
            labels: vocLabels,
            modals: vocModals,
            drawers: vocDrawers,
            onboarding: vocOnboarding,
        },
    },
    layouts,
    blacklist,
    dashboards,
    guides: {
        ...guides,
        modules: {
            nps,
            resourceCenter,
        },
    },
    users,
    usersMinimal,
    feedbackRequests,
    teams,
    surveys,
    feedbackLinking: {
        ...feedbackLinking,
        modules: {
            vendors,
            products,
            permissionGroups,
            signingKeys,
            vendorUsers,
        },
    },
    guideCategories,
    guideModals,
    journeys: {
        ...journeys,
        modules: {
            graph,
        },
    },
    statuses,
    metaGroups,
    dataSync,
    leftNav,
    essentialContacts,
    vocPortal,
    feedbackStatuses,
    pages: {
        ...pages,
        modules: {
            suggestedPages,
        },
    },
    apps,
    themes,
    metadata,
    superTools,
    smartSegments,
    notifications,
    ngRoute,
    vocPollWizard,
    billing,
    segments,
    localization,
    savedReports: {
        ...savedReports,
        modules: {
            paths,
            funnels,
        },
    },
    automationRules,
    aiFlags,
};
